export default __webpack_public_path__ + "922a446200a536b36ed88cc2a3d09ca6.png";